import { render, staticRenderFns } from "./ObservationOrder.vue?vue&type=template&id=35f419c5&"
import script from "./ObservationOrder.vue?vue&type=script&lang=js&"
export * from "./ObservationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ObservationOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports